import { render, staticRenderFns } from "./TemplatesMain.vue?vue&type=template&id=438aef4c&"
import script from "./TemplatesMain.vue?vue&type=script&lang=js&"
export * from "./TemplatesMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports